/* eslint  max-classes-per-file: 0 */ // --> OFF
export class DatePickerEx extends kendo.ui.DatePicker {
    value(value?: any): any {
        if (typeof (value) === "string") {
            const date: Date = new Date(value);
            // Checks if the original string really was a Date.toString() value
            if (!Number.isNaN(date.valueOf()) && date.toString() === value) {
                return super.value(date);
            }
        }
        return super.value(value);
    }
}

// Create an alias of the prototype (required by kendo.ui.plugin)
DatePickerEx.fn = DatePickerEx.prototype;
// Deep clone the widget default options
DatePickerEx.fn.options = $.extend(true, {}, kendo.ui.DatePicker.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
DatePickerEx.fn.options.name = "DatePickerEx";
// Create a jQuery plugin.
kendo.ui.plugin(DatePickerEx);

export class DateTimePickerEx extends kendo.ui.DateTimePicker {
    value(value?: any): any {
        if (typeof (value) === "string") {
            const date: Date = new Date(value);
            // Checks if the original string really was a Date.toString() value
            if (!Number.isNaN(date.valueOf()) && date.toString() === value) {
                return super.value(date);
            }
        }
        return super.value(value);
    }
}

// Create an alias of the prototype (required by kendo.ui.plugin)
DateTimePickerEx.fn = DateTimePickerEx.prototype;
// Deep clone the widget default options
DateTimePickerEx.fn.options = $.extend(true, {}, kendo.ui.DateTimePicker.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
DateTimePickerEx.fn.options.name = "DateTimePickerEx";
// Create a jQuery plugin.
kendo.ui.plugin(DateTimePickerEx);

export class YearlessDatePicker extends kendo.ui.DatePicker {
    constructor(element: Element, options?: kendo.ui.DatePickerOptions) {
        super(element, options);

        const that = this as any;
        const dateView = that.dateView;
        that._update = this.updateEx;
        dateView._calendar();
        dateView.baseOpen = dateView.open;
        dateView.calendar.baseNavigate = dateView.calendar.navigate;
        dateView.calendar.baseNavigateUp = dateView.calendar.navigateUp;
        dateView.open = this.open;
        dateView.calendar.navigate = this.navigate;
        dateView.calendar.navigateUp = this.navigateUp;
        dateView.calendar.setTitle = this.setTitle;
    }

    // Function override to set year to 400
    updateEx(value) {
        const that = this as any;
        const current = that._value;
        let date = kendo.parseDate(value, that.options.parseFormats, that.options.culture);
        if (date) {
            date.setFullYear(400);
        }
        const isSameType = (date === null && current === null) || (date instanceof Date && current instanceof Date);
        let formattedValue;
        if (that.options.disableDates(date)) {
            date = null;
            if (!that._old && !that.element.val()) {
                value = null;
            }
        }
        if (+date === +current && isSameType) {
            formattedValue = kendo.toString(date, that.options.format, that.options.culture);
            if (formattedValue !== value) {
                that.element.val(date === null ? value : formattedValue);
            }
            return date;
        }
        that._value = date;
        that.dateView.value(date);
        that.element.val(kendo.toString(date || value, that.options.format, that.options.culture));
        that._updateARIA(date);
        return date;
    }

    open(): void {
        const that = this as any;
        that.baseOpen();
        that.calendar.setTitle(that.calendar._current);
    }

    navigate(value: Date, view) {
        const that = this as any;
        that.baseNavigate(value, view);
        that.setTitle(value || that._value);
    }

    navigateUp() {
        const that = this as any;
        if (that.view().name === "month") {
            that.baseNavigateUp();
        }
    }

    setTitle(value: Date): void {
        const that = this as any;
        if (that.view().name === "month") {
            that._title.html((kendo.cultures[that.options.culture] || (kendo.cultures as any).current).calendar.months.names[value.getMonth()]);
        } else if (that.view().name === "year") {
            that._title.html(TextResources.Views_Monate);
        }
    }
}

// Create an alias of the prototype (required by kendo.ui.plugin)
YearlessDatePicker.fn = YearlessDatePicker.prototype;
// Deep clone the widget default options
YearlessDatePicker.fn.options = $.extend(true, {}, kendo.ui.DatePicker.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
YearlessDatePicker.fn.options.name = "YearlessDatePicker";
// Create a jQuery plugin.
kendo.ui.plugin(YearlessDatePicker);

interface JQuery {
    kendoDatePickerEx(options?: kendo.ui.DatePickerOptions): JQuery;
    kendoDateTimePickerEx(options?: kendo.ui.DateTimePickerOptions): JQuery;
    kendoYearlessDatePicker(options?: kendo.ui.DatePickerOptions): JQuery;
}
